import { BASE_API_URL, handleAPIResponse } from './Base';

export async function getSummary() {
  const response = await fetch(`${BASE_API_URL}/summary`)
  return await handleAPIResponse(response)
}
